import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { qk } from '../Api/queryClient';
import {
  listRetailers, createRetailer, getRetailer, updateRetailer,
  getRetailerStations, getRetailerVisits,
} from '../Api/retailersApi';

export function useRetailerList(search) {
  return useQuery({ queryKey: qk.retailerList(search), queryFn: () => listRetailers(search) });
}

export function useRetailer(cmGuid) {
  return useQuery({ queryKey: qk.retailerDetail(cmGuid), queryFn: () => getRetailer(cmGuid), enabled: !!cmGuid });
}

export function useRetailerStations(cmGuid) {
  return useQuery({ queryKey: ['sfa', 'detail', 'retailer-stations', cmGuid], queryFn: () => getRetailerStations(cmGuid), enabled: !!cmGuid });
}

export function useRetailerVisits(cmGuid) {
  return useQuery({ queryKey: ['sfa', 'detail', 'retailer-visits', cmGuid], queryFn: () => getRetailerVisits(cmGuid), enabled: !!cmGuid });
}

export function useCreateRetailer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createRetailer,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['sfa', 'list', 'retailers'] });
      toast.success('Retailer created.');
    },
    onError: (err) => toast.error(err?.friendlyMessage || 'Could not create retailer.'),
  });
}

export function useUpdateRetailer(cmGuid) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload) => updateRetailer(cmGuid, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['sfa', 'list', 'retailers'] });
      qc.invalidateQueries({ queryKey: qk.retailerDetail(cmGuid) });
      toast.success('Retailer updated.');
    },
    onError: (err) => toast.error(err?.friendlyMessage || 'Could not update retailer.'),
  });
}
